
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Random } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;
        @Prop( { type: String, default: '*' } ) public accept: string;

        @Prop()
        public value: any;

        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            this.Selected = this.value;
        }


        @Prop( { type: Boolean } )
        public Abierto: boolean;
        public InputId: string = 'ac';

        @Watch( 'Abierto' )
        onAbierto()
        {
            this.Selected = null;
            document.getElementById( this.InputId )?.click();
        }


        constructor()
        {
            super();
        }

        public selected: any | null | 'none' = null;
        //@Watch( 'selected', { deep: true } )
        onSelected()
        {

        }

        public get Selected(): any 
        {
            return this.selected;
        }

        public set Selected( x: any )
        {
            this.selected = x;
            if ( x != 'none' )
            {
                this.$emit( 'input', x );
                this.$emit( 'change', x );
                this.selected = null;
            } 
           
        }


        public async buscar()
        {

        }

        public Archivo: any = null;

        created()
        {
            this.InputId = 'file-input-' + Random.Enteros( 1, 10000 );
        }
    }
